<template>
  <a-form-model-item :label="field.label" :label-col="labelCol" :wrapper-col="wrapperCol">
    <template v-if="field.key === 'title'">
      <a-input :value="form[field.key]" placeholder="反馈标题" @change="e => updateForm(field.key, e.target.value)" />
    </template>

    <template v-else-if="field.key === 'status'">
      <a-select :value="form[field.key]" style="width: 100%" placeholder="反馈状态" allow-clear @change="value => updateForm(field.key, value)">
        <a-select-option v-for="(item, key) in options.statusList" :key="key" :value="item.value">
          <a-tag :color="item.color">{{ item.label }}</a-tag>
        </a-select-option>
      </a-select>
    </template>

    <template v-else-if="field.key === 'user_id'">
      <user-select :value="form[field.key]" show-all show-search placeholder="反馈创建人" allow-clear @change="value => updateForm(field.key, value)" />
    </template>

    <template v-else-if="field.key === 'type'">
      <a-select :value="form[field.key]" style="width: 100%" placeholder="选择反馈类型" allow-clear @change="value => updateForm(field.key, value)">
        <a-select-option v-for="(item, key) in options.types" :key="key" :value="item.value">
          <a-tag :color="item.color">{{ item.label }}</a-tag>
        </a-select-option>
      </a-select>
    </template>
  </a-form-model-item>
</template>

<script>
import UserSelect from '@/components/User/UserSelect';

export default {
  name: 'FeedbackFilterFormItem',
  components: {
    UserSelect
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    labelCol: {
      type: Object,
      default: () => ({ span: 6 })
    },
    wrapperCol: {
      type: Object,
      default: () => ({ span: 18 })
    }
  },
  methods: {
    updateForm(key, value) {
      const updatedForm = { ...this.form, [key]: value };
      this.$emit('update:form', updatedForm);
      this.$emit('change', { key, value });
    }
  }
};
</script>
